import React, { FC } from 'react';
import classNames from 'classnames';
import grid from '@/common/css/grid.module.scss';
import styles from './Video.module.scss';

interface VideoProps {
  url: string;
}

const Video: FC<VideoProps> = ({
  url,
}) => (
  <div className={grid.row}>
    <div className={classNames(grid.colLg10, grid.offsetLg1)}>
      <div className={styles.wrapper}>
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.video}
          src={url}
          title="Careers"
        />
      </div>
    </div>
  </div>
);
Video.displayName = 'Video';

export default Video;
